var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-legend"},_vm._l((_vm.legendItems),function(ref){
var backgroundColor = ref.backgroundColor;
var color = ref.color;
var label = ref.label;
var key = ref.key;
return _c('div',{key:key,staticClass:"legend-item",style:({ backgroundColor: backgroundColor, color: color })},[_vm._v(" "+_vm._s(label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }